import { ShareSceneEnum, ShareTypeEnum } from '@/interface/downAppType';
import http from './http';
import apiEnum from './apiEnum';

export interface ModuleVo {
  moduleName: string; // 微信wx 朋友圈friend 猫友圈catFriend 复制链接copyUrl 群聊group 下载图片loadImg
  title: string; // 微信 朋友圈 猫友圈 群聊 下载图片
  type?: number; // 0-兜底卡片分享
  icon?: string; // 自定义icon
}

// 通用分享详情查询接口
export interface ReqShareDetail {
  token?: string; /** token */
  shareId: string; /** 分享id */
}

export interface ResShareDetail {
  extraInfo?: any; /** 注释 */
  shareId?: string; /** 新用户分享id */
  shareUserId?: string /** 老用户分享id */
}

// 获取分享链接
export interface ReqGetShareLink {
  catHouseId?: string; /** 猫屋Id */
  userId?: string; /** 用户Id */
  sceneId: number;/** 场景Id */
  businessId?: string; /** 业务id */
  extraInfo?: any; /** 额外数据 */
  // token: string; /** 注释 */
}

// 参与活动
export interface ReqParticipateActivity {
  activityId: string; /** 活动ID */
  name: string; /** 姓名 */
  shareId?: string; /** 分享ID */
  token: string; /** 登陆状态 */
}
export interface ResParticipateActivity {
  activityPictureUrl: string; /** 活动图片url */
  participationRank: number; /** 参与名次 */
}

export interface ResGetShareLink {
  shareQrCodeUrl?: string; /** 分享短链接 */
  title?: string; /** 分享到群聊标题 */
  subTitle?: string; /** 分享到群聊副标题 */
  name?: string; /** 直播间名称 */
  coverImage?: string; /** 封面图 */
  url?: string; /** 通用链接 */
  icon?: string; /** 分享到群聊icon */
  h5url?: string; /** h5 url */
  h5Url?: string; /** h5 url */
  shareId?: string; /** 分享id */
  shareForm?: string; /** 分享来源 */
  sceneId?: ShareSceneEnum; /** 分享场景 */
  shareType?: ShareTypeEnum;
}

export interface UBTModuleExposeData {
  UBTName: any;
  moduleId: string;
  businessInfo: any;
}

/**
 * 通用分享详情查询接口Api
 * @param data
 * @returns
 */

export const requestShareDetailApi = (param: ReqShareDetail): Promise<{
  code: number;
  data: ResShareDetail;
  msg: string;
}> => http.post({
  action: apiEnum.shareDetailAction,
  data: param,
});

/**
 * 获取分享链接Api
 * @param data
 * @returns
 */

export const requestPublicShareLinkApi = (param: ReqGetShareLink): Promise<{
  code: number;
  data: ResGetShareLink;
  msg: string;
}> => http.post({
  action: apiEnum.getPublicShareLinkAction,
  data: param,
});

/**
 * 获取分享出去的参数Api
 * @param data
 * @returns
 */
export const requestGetShareLinkApi = (param: ReqGetShareLink): Promise<{
  code: number;
  data: ResGetShareLink;
  msg: string;
}> => http.post({
  action: apiEnum.getShareLinkAction,
  data: param,
});

export interface CustomEventOptions {
  scene?: number; // 场景值
  code?: number; // 状态码
  duration?: number; // 停留时长：单位毫秒
  over_one_second?: number; // 是否大于1秒：1-是 0-否
  live_block_time?: number; // 卡顿时间：单位毫秒
  live_play_all_time?: number; // 直播总时间：单位毫秒
  is_show?: number; // 是否在用户视线中: 1-是 0-否
  appSource?: string; // 应用来源，小程序为空
  eventCreateTime?: string | number; // 次留时间
  systemCode?: string; // 端口来源
  userNewId?: string; // 用户登录后的id
  appId?: string; // 微信小程序/公众号唯一标识
  openID?: string; // 小程序用户id
  desc?: string; // 描述信息
  dirty?: number; // 是否脏数据 0-否 1-是
}

// 查询活动详情
export interface ReqGetActivityDetailByType {
  activityType: number; /** 活动类型 */
  userId?: string; /** 用户id (登录状传） */
  token?: string; /** 活动token */
}

export interface ResGetActivityDetailByType {
  activityPictureUrl?: string; /** 活动图片url */
  activityDesc?: string; /** 活动说明 */
  activityText?: string; /** 活动文案 */
  activityVideoUrl?: string; /** 活动视频链接 */
  activityUserNum?: number; /** 参与活动用户数 */
  activityBackgroundUrl?: string; /** 活动背景图 */
  participatedFlag?: boolean; /** 是否参与过活动 */
  buttonBackgroundUrl?: string; /** 活动按钮背景图 */
  nodes?: any
  descNodes?: any
  activityId: string; /** 活动id */
  participationRank?: number
}

/**
 * 查询活动详情Api
 * @param data
 * @returns
 */

export const requestGetActivityDetailByTypeApi = (param: ReqGetActivityDetailByType): Promise<{
  code: number;
  data: ResGetActivityDetailByType;
  msg: string;
}> => http.post({
  action: apiEnum.getActivityDetailByTypeAction,
  data: param,
});

export const requestGetActivityDetailByTypeApiLogin = (param: ReqGetActivityDetailByType): Promise<{
  code: number;
  data: ResGetActivityDetailByType;
  msg: string;
}> => http.post({
  action: apiEnum.getActivityDetailByTypeForLoginAction,
  data: param,
});

export const requestParticipateActivity = (param: ReqParticipateActivity): Promise<{
  code: number;
  data: ResParticipateActivity;
  msg: string;
}> => http.post({
  action: apiEnum.requestParticipateActivityAction,
  data: param,
});

// 视频详情接口类型定义
export interface ReqGetUserFeedShareDetail {
  userFeedId: string; /** 动态id */
  userId?: string; /** 用户id */
}

export interface CatLabel {
  id?: string;
  catLabelId?: string; /** 标记猫id */
  name?: string; /** 名字 */
  avatar?: string; /** 头像 */
  catHouseId?: string; /** 猫屋id */
  labelTimes?: number; /** 标记次数 */
  createBy?: string; /** 创建人 */
  userNickname?: string; /** 创建人昵称 */
  createTime?: string; /** 创建时间 */
}

export interface FeedPicture {
  feedPicture?: string; /** 图片 */
  catLabels?: CatLabel[]; /** 标记猫 */
}

export interface FeedVideo {
  url?: string; /** 视频链接 */
  orientation?: string; /** 视频画面方向 */
  feedPicture?: string; /** 动态图片 */
  catLabels?: CatLabel[];
}

export interface UserFeedCatInfo {
  feedQuantity?: number; /** 发送人投喂数量 */
  feedCatCount?: number; /** 发送人喂饱猫的数量 */
}

export interface TopicInfo {
  id?: string;
  topic?: string;
  type?: number; /** 话题类型,1, "普通话题";2, "挑战话题";3,"特殊话题" */
  url?: string; /** 跳转链接 */
}

export interface ChallengeTopic {
  id?: string;
  topic?: string;
  avatar?: string;
}

export interface ProductInfo {
  id?: string; /** 商品id */
  itemId?: string; /** 第三方商品id */
  clickUrl?: string; /** 商品推广链接 */
}

export interface PromotionContent {
  pic?: string; /** 图片 */
  title?: string; /** 标题 */
  subTitle?: string; /** 副标题 */
  displayButton?: boolean; /** 是否显示按钮 */
  buttonText?: string; /** 按钮文案 */
  linkType?: number; /** 链接类型，1-淘宝商品、2-京东商品、3-拼多多商品，501-h5页面，601-小程序 */
  link?: string; /** 链接，linkType=501/601 */
  productId?: string; /** 商品id，linkType=1/2/3 */
  product?: ProductInfo; /** 商品，linkType=1/2/3 */
}

export interface NewbieVideoTask {
  taskAwardCoinNum?: number; /** 任务奖励爱心币数量 */
  taskDuration?: string; /** 任务时长 */
  taskIdempotent?: string; /** 任务密钥 */
}

export interface LocationInfo {
  provinceCode?: string; /** 省份code */
  cityCode?: string; /** 城市code */
  countyAdCode?: string; /** 区编码 */
  adCode?: string; /** 街道code */
  provinceName?: string; /** 省份名称 */
  cityName?: string; /** 城市名称 */
  countyAdName?: string; /** 区名称 */
  adName?: string; /** 街道名称 */
}

export interface DetailConfigOption {
  optionCode?: string; /** 选项code */
  optionName?: string; /** 选项名称 */
}

export interface DetailConfigItem {
  itemName?: string; /** 选项名称 */
  itemCode?: string; /** 选项code码 */
  optionValue?: DetailConfigOption[]; /** 选项列表 */
}

export interface CatHouseInfo {
  catHouseId?: string; /** 猫屋id */
  catHouseName?: string; /** 猫屋名称 */
}

export interface WishOrderItem {
  wishOrderId?: string; /** 心愿单id */
  wishOrdeName?: string; /** 心愿单名称 */
  catAvatar?: string; /** 猫头像 */
  crowdPercentage?: string; /** 众筹百分比 */
  crowdFundUserCount?: number; /** 众筹人数 */
  status?: number; /** 2020-众筹进行中，2030-众筹成功 */
}

export interface WishOrder {
  wishOrderList?: WishOrderItem[];
}

export interface CatArchiveItem {
  catArchiveId?: string; /** 猫档案id */
  catAvatar?: string; /** 猫头像 */
  catName?: string; /** 猫名称 */
}

export interface CatArchive {
  catArchiveList?: CatArchiveItem[];
}

export interface SupplementInfo {
  catHouse?: CatHouseInfo; /** 猫屋 */
  wishOrder?: WishOrder; /** 心愿单 */
  location?: LocationInfo; /** 位置数据 */
  detailConfig?: DetailConfigItem[]; /** 领养+是否有偿数据 */
  catArchive?: CatArchive;
}

export interface ResGetUserFeedShareDetail {
  id?: string; /** 动态id */
  contentType?: number; /** 动态类型 1-图文，2-视频 */
  feedCategoryType?: number; /** 动态类别类型 */
  content?: string; /** 动态内容 */
  sendUserId?: string; /** 动态发送人id */
  nickname?: string; /** 发送人昵称 */
  avatar?: string; /** 发送人头像 */
  catHouseId?: string; /** 猫屋ID */
  catHouseName?: string; /** 猫屋名称 */
  newbieVideoTask?: NewbieVideoTask; /** 观看新手视频任务信息 */
  picture?: FeedPicture[]; /** 图片 */
  videos?: FeedVideo[]; /** 视频 */
  isPrefer?: number; /** 当前用户是否点赞 0-否 1-是 */
  preferCount?: number; /** 点赞数量 */
  commentCount?: number; /** 评论数量 */
  shareCount?: number; /** 分享人数 */
  userFeedCatInfo?: UserFeedCatInfo; /** 用户投喂信息 */
  followFlag?: boolean; /** 关注状态 true 关注 false 未关注 */
  shareTitle?: string; /** 分享主标题 */
  shareSubTitle?: string; /** 分享副标题 */
  isShield?: number; /** 是否屏蔽0-否 1-是 */
  topicList?: TopicInfo[];
  challengeTopic?: ChallengeTopic; /** 挑战话题 */
  promotionContent?: PromotionContent; /** 推广内容 */
  adRelationId?: string; /** 资源位资源id */
  title?: string; /** 标题 */
  feedCategoryId?: string; /** 动态类别id */
  feedCategoryName?: string; /** 动态类别名称 */
  provinceName?: string; /** 省份名称 */
  feedSupplementInfo?: SupplementInfo; /** 补充信息 */
  createTime?: string; /** 创建时间 */
  updateTime?: string; /** 更新时间 */
  formatTime?: string; /** 格式化时间 */
}

/**
 * 获取动态详情接口Api
 * 功能：根据动态ID获取视频/图文动态的详细信息
 * 输入：ReqGetUserFeedShareDetail - 包含动态ID和用户ID
 * 输出：Promise<ResGetUserFeedShareDetail> - 返回动态详情数据
 * @param param - 请求参数
 * @returns Promise<动态详情响应>
 */
export const requestGetUserFeedShareDetailApi = (param: ReqGetUserFeedShareDetail): Promise<{
  code: number;
  data: ResGetUserFeedShareDetail;
  message: string;
}> => {
  console.log('发起获取动态详情请求:', param);
  return http.post({
    action: apiEnum.getUserFeedShareDetailAction,
    data: param,
  });
};

// 评论接口类型定义
export interface ReqQueryFeedCommentPage {
  userFeedId: string; /** 动态id */
  curPage?: number; /** 当前页码 */
  pageSize?: number; /** 每页数量 */
}

export interface CommentReply {
  id?: string;
  commentType?: number; /** 评论类型3-评论5-回复 */
  commentUserId?: string; /** 评论用户ID */
  userName?: string; /** 评论人名称 */
  replyCommentId?: string; /** 被回复评论id */
  replyUserId?: string; /** 被回复人Id */
  replyUserName?: string; /** 被回复人名称 */
  content?: string; /** 评论内容 */
  originCommentId?: string; /** 原始评论ID */
  createTime?: string; /** 创建时间 */
  region?: string; /** 定位，城市 */
  preferCount?: number; /** 点赞数量 */
  isPrefer?: number; /** 是否自己点赞，0-不是，1-是 */
}

export interface CommentItem {
  id?: string; /** 评论id */
  commentType?: number; /** 评论类型3-评论5-回复 */
  commentUserId?: string; /** 评论用户ID */
  userName?: string; /** 评论人名称 */
  avatar?: string; /** 评论人头像 */
  content?: string; /** 评论内容 */
  commentReplyCount?: number; /** 评论回复条数 */
  createTime?: string; /** 创建时间 */
  region?: string; /** 定位，城市 */
  preferCount?: string; /** 点赞数量 */
  isPrefer?: string; /** 是否自己点赞，0-不是，1-是 */
  commentReplyList?: CommentReply[]; /** 评论回复列表 */
  commentShowReplyList?: CommentReply[]; /** 评论回复列表 */
}

export interface CommentPageInfo {
  curPage?: string;
  pageSize?: string;
  total?: string;
  pages?: string;
}

export interface ResQueryFeedCommentPage {
  page?: CommentPageInfo;
  records?: CommentItem[];
}

/**
 * 分页查询动态评论接口Api
 * 功能：根据动态ID分页查询评论列表
 * 输入：ReqQueryFeedCommentPage - 包含动态ID和分页参数
 * 输出：Promise<ResQueryFeedCommentPage> - 返回评论列表数据
 * @param param - 请求参数
 * @returns Promise<评论列表响应>
 */
export const requestQueryFeedCommentPageApi = (param: ReqQueryFeedCommentPage): Promise<{
  code: number;
  data: ResQueryFeedCommentPage;
  message: string;
}> => {
  console.log('发起获取评论列表请求:', param);
  return http.post({
    action: apiEnum.queryFeedCommentPageAction,
    data: param,
  });
};
